import currencies from '@/util/currencies'

/**
 * Highest odds first. The list row shows only its leading outcomes, so it leads with the
 * ones a trader is most likely to act on rather than whichever the payload listed first.
 */
export const rankOutcomesByPrice = (outcomes = [], currencyId) =>
  Array.from(outcomes).sort((a, b) => (b?.price?.[currencyId] ?? 0) - (a?.price?.[currencyId] ?? 0))

/** Which price on an outcome applies: play money has its own, real money the market's. */
export const priceCurrencyIdFor = (question, activeCurrencyId) =>
  activeCurrencyId === currencies.OOM.id ? currencies.OOM.id : question?.canonical_currency

/**
 * The outcome a row leads with — what its first button shows and what clicking the row
 * body picks. A fixture keeps the payload's order, which its own list reads as
 * home/draw/away; every other market leads with the highest odds.
 */
export const leadingRowOutcomeFor = (question, activeCurrencyId, { isFixture = false } = {}) =>
  isFixture
    ? question?.outcomes?.[0]
    : rankOutcomesByPrice(question?.outcomes, priceCurrencyIdFor(question, activeCurrencyId))[0]
